import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDiP_UWKs3ePM1e7cX-Vo37iWUZlf8sxGM",
  authDomain: "jatear-lms.firebaseapp.com",
  projectId: "jatear-lms",
  storageBucket: "jatear-lms.firebasestorage.app",
  messagingSenderId: "646443377080",
  appId: "1:646443377080:web:27dd13dce0613d0f82ef4d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'southamerica-east1');

// messaging pode ser null em browsers sem suporte a Push API
export let messaging = null;
isSupported().then(ok => {
  if (ok) messaging = getMessaging(app);
}).catch(() => {});

export default app;